import React from "react";
import { useMsal, useIsAuthenticated } from "@azure/msal-react";
import { loginRequest } from "./authConfig";

export default function LoginGate() {
  const { instance, inProgress } = useMsal();
  const isAuthenticated = useIsAuthenticated();

  // Optional: if something signals "interaction required", we can act here too
  const [interactionRequired, setInteractionRequired] = React.useState(false);

  React.useEffect(() => {
    const onNeedInteraction = () => setInteractionRequired(true);
    window.addEventListener("auth:interaction-required", onNeedInteraction);
    return () => window.removeEventListener("auth:interaction-required", onNeedInteraction);
  }, []);

  React.useEffect(() => {
    if (isAuthenticated) return;

    // either user is simply unauthenticated, or we were told interaction is needed
    if ((interactionRequired || true) && inProgress === "none") {
      instance.loginRedirect(loginRequest);
    }
  }, [isAuthenticated, interactionRequired, inProgress, instance]);

  return <p>Redirecting to sign in…</p>;
}